import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { IApplicationContext } from 'interfaces/i-application-context-props'
import {
	ApplicationDispatchContext,
	LOAN_APPLICATION_ACTIONS,
} from 'contexts/ApplicationContext'
import { MSP_ACTIONS, MspDispatchContext } from 'components/multistep/Multistep'
import { isPnStatusSigned, onPnSignClick } from 'utils/loanHelpers'
import CircleSpinner from 'components/circle-spinner/CircleSpinner'
import ButtonSpinner from 'components/button-spinner/ButtonSpinner'
import '../SignPn.scss'
import { useApplicationData } from 'hooks/useApplicationData'

export const SignPnIt = () => {
	const { t } = useTranslation()
	const { loanApplication, dispatchLoanApplication }: IApplicationContext =
		useContext(ApplicationDispatchContext)
	const { msp, dispatchMsp } = useContext(MspDispatchContext)
	const [loading, setLoading] = useState<boolean>(false)
	const [errorMessage, setErrorMessage] = useState<string | null>(null)
	const [loanConditionsAccepted, setLoanConditionsAccepted] = useState<boolean>(false)
	const [confirmDataValid, setConfirmDataValid] = useState<boolean>(false)

	const applicationId =
		loanApplication.applicationData?.loanNumber.toString() ||
		sessionStorage.getItem('applicationid') ||
		null

	const { applicationData, loading: applicationLoading } = useApplicationData(
		{ applicationId, t }
	)

	useEffect(() => {
		if (applicationData) {
			dispatchLoanApplication({
				type: LOAN_APPLICATION_ACTIONS.SET_UPDATE_APPLICATIONDATA,
				payload: applicationData,
			})
		}
	}, [applicationData, dispatchLoanApplication])

	useEffect(() => {
		const checkPnStatus = () => {
			if (isPnStatusSigned(applicationData!)) {
				next()
			}
		}
		if (applicationData) {
			checkPnStatus()
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [applicationData])

	const signClick = () => {
		const status = applicationData?.lifeCycleStatus.toLowerCase()
		if (status === 'denied' || status === 'canceled') {
			setErrorMessage(t('ApplicationRejectedPsd2'))
			return
		}
		setLoading(true)
		onPnSignClick(applicationData!, loanApplication.signingUrls!, t)
	}

	const next = () => {
		dispatchMsp({
			type: MSP_ACTIONS.SET_INDEX,
			payload: {
				index: msp.index + 1,
			},
		})
	}

	return (
		<div className="sign-pn">
			<div className="signing-section">
				<h6>{t('PromissoryNote')}</h6>
				{applicationLoading ? (
					<CircleSpinner />
				) : (
					<>
						<div className="sign-pn-information-section">
							<div>{t('PromissoryNoteSigningLine2')}</div>
						</div>
						<div className="sign-pn-checkbox-section">
							<label className="checkbox-container mt-2">
								<input
									id="sign-pn-loan-conditions-checkbox"
									type="checkbox"
									name="loanConditionsAccepted"
									className={`required-step ${
										loanConditionsAccepted
											? 'completed-step'
											: ''
									}`}
									onChange={() =>
										setLoanConditionsAccepted(
											!loanConditionsAccepted,
										)
									}
									checked={loanConditionsAccepted}
								/>
								<span className="checkmark"></span>
								<p>{t('LoanConditionsLabel')}</p>
							</label>
							<label className="checkbox-container mt-2">
								<input
									id="sign-pn-confirm-data-checkbox"
									type="checkbox"
									name="confirmDataValid"
									className={`required-step ${
										confirmDataValid ? 'completed-step' : ''
									}`}
									onChange={() =>
										setConfirmDataValid(!confirmDataValid)
									}
									checked={confirmDataValid}
								/>
								<span className="checkmark"></span>
								<p>{t('ConfirmValidDataLabel')}</p>
							</label>
						</div>
						{errorMessage && (
							<div className="error-message">{errorMessage}</div>
						)}
						<div className="sign-pn-button-section">
							<button
								id="signPnBtnIt"
								className="btn btn-primary no-ripple"
								onClick={signClick}
								disabled={
									loading ||
									!!errorMessage ||
									!loanConditionsAccepted ||
									!confirmDataValid
								}>
								{loading ? (
									<div className="sign-pn-spinner-container">
										<ButtonSpinner />
									</div>
								) : (
									t('SIGNPN')
								)}
							</button>
						</div>
					</>
				)}
			</div>
		</div>
	)
}
